import { gqlQuery, gqlMutate } from '@hapana/shared/web/services/requests.service'
import {
  clientServicesQuery,
  serviceCreditUsageHistoryQuery,
  serviceCreditSummaryPeriodsQuery,
  serviceCreditAdjustmentNotesQuery,
  availablePlanOptionsQuery,
  calculateCartQuery,
  serviceTemplateAgreementQuery,
  CLIENT_SERVICES_QUERY_KEY,
  SERVICE_CREDIT_USAGE_HISTORY_QUERY_KEY,
  SERVICE_CREDIT_SUMMARY_PERIODS_QUERY_KEY,
  SERVICE_CREDIT_ADJUSTMENT_NOTES_QUERY_KEY,
  AVAILABLE_PLAN_OPTIONS_QUERY_KEY,
  CALCULATE_CART_QUERY_KEY,
  PREVIEW_PLAN_CHANGE_QUERY_KEY,
  SERVICE_TEMPLATE_AGREEMENT_QUERY_KEY,
  previewMembershipPlanChangeQuery,
} from './client-packages.queries'
import {
  adjustPackageExpiryMutation,
  adjustServiceCreditsMutation,
  suspendServiceMutation,
  resumeServiceMutation,
  cancelServiceMutation,
  restoreServiceMutation,
  cancelScheduledSuspensionMutation,
  cancelScheduledCancellationMutation,
  changeMembershipPlanMutation,
  cancelScheduledPlanChangeMutation,
} from './client-packages.mutations'

// Query services
export const fetchClientServices = gqlQuery({
  key: CLIENT_SERVICES_QUERY_KEY,
  query: clientServicesQuery,
})

export const fetchServiceCreditUsageHistory = gqlQuery({
  key: SERVICE_CREDIT_USAGE_HISTORY_QUERY_KEY,
  query: serviceCreditUsageHistoryQuery,
})

export const fetchServiceCreditSummaryPeriods = gqlQuery({
  key: SERVICE_CREDIT_SUMMARY_PERIODS_QUERY_KEY,
  query: serviceCreditSummaryPeriodsQuery,
})

export const fetchServiceCreditAdjustmentNotes = gqlQuery({
  key: SERVICE_CREDIT_ADJUSTMENT_NOTES_QUERY_KEY,
  query: serviceCreditAdjustmentNotesQuery,
})

// Mutation services
export const adjustServiceCredits = (variables: {
  input: {
    serviceId: string
    siteId: string
    amount: number
    direction: 'IN' | 'OUT'
    notes?: string
    reason?: string
    siteSessionTypeId?: string
    periodId?: string
  }
}) => gqlMutate({ mutation: adjustServiceCreditsMutation, variables })

export const adjustPackageExpiry = (variables: {
  serviceId: string
  expiresAtDate: string
  siteId: string
}) => gqlMutate({ mutation: adjustPackageExpiryMutation, variables })

export const suspendService = (variables: {
  serviceId: string
  startDate?: string
  endDate?: string
  reason?: string
  chargeMode?: string
  chargeAmount?: string
  bookingIds?: string[]
  failedInvoiceIds?: string[]
  siteId: string
}) => gqlMutate({ mutation: suspendServiceMutation, variables })

export const resumeService = (variables: { serviceId: string; notes?: string; siteId: string }) =>
  gqlMutate({ mutation: resumeServiceMutation, variables })

export const cancelService = (variables: {
  serviceId: string
  reason?: string
  cancelAt?: string
  bookingIds?: string[]
  failedInvoiceIds?: string[]
  siteId: string
}) => gqlMutate({ mutation: cancelServiceMutation, variables })

export const restoreService = (variables: { serviceId: string; notes?: string; siteId: string }) =>
  gqlMutate({ mutation: restoreServiceMutation, variables })

export const cancelScheduledSuspension = (variables: {
  serviceSuspensionId: string
  reason?: string
  siteId: string
}) => gqlMutate({ mutation: cancelScheduledSuspensionMutation, variables })

export const cancelScheduledCancellation = (variables: {
  serviceCancellationId: string
  reason?: string
}) => gqlMutate({ mutation: cancelScheduledCancellationMutation, variables })

export const fetchAvailablePlanOptions = gqlQuery({
  key: AVAILABLE_PLAN_OPTIONS_QUERY_KEY,
  query: availablePlanOptionsQuery,
})

export const fetchCalculateCart = gqlQuery({
  key: CALCULATE_CART_QUERY_KEY,
  query: calculateCartQuery,
})

export const fetchPreviewMembershipPlanChange = gqlQuery({
  key: PREVIEW_PLAN_CHANGE_QUERY_KEY,
  query: previewMembershipPlanChangeQuery,
})

export const fetchServiceTemplateAgreement = gqlQuery({
  key: SERVICE_TEMPLATE_AGREEMENT_QUERY_KEY,
  query: serviceTemplateAgreementQuery,
})

export const changeMembershipPlan = (variables: {
  input: {
    siteId: string
    serviceId: string
    toServiceTemplateId: string
    effectiveType: 'Immediate' | 'EndOfCycle'
    reason?: string
    signedClientAgreementId?: string
  }
}) => gqlMutate({ mutation: changeMembershipPlanMutation, variables })

export const cancelScheduledPlanChange = (variables: {
  input: { servicePlanChangeId: string; siteId: string }
}) => gqlMutate({ mutation: cancelScheduledPlanChangeMutation, variables })
